import NoData from 'components/general/NoData/NoData'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import { renderDocuments } from 'components/widgets/DocumentsWidget'

const RequisitionDocuments = (props) => {
	const { documents } = props
	const { i18n, openFile } = useGlobal()

	return (
		<>
			{!documents?.length ? (
				<NoData
					applyMaxWidth
					paddings={['normal', 'normal']}
					message={i18n`This process has no extra data to show.`}
				/>
			) : (
				<>{renderDocuments(documents || [], i18n, openFile)}</>
			)}
		</>
	)
}

export default RequisitionDocuments
